import { APICallV3Get } from 'reactApp/api/APICall';

export class GiftReceivedAPICall extends APICallV3Get {
    _method = 'billing/gift/receiving';
}
